import { render, staticRenderFns } from "./ClassificationTile.vue?vue&type=template&id=730651dc&scoped=true&"
import script from "./ClassificationTile.vue?vue&type=script&lang=js&"
export * from "./ClassificationTile.vue?vue&type=script&lang=js&"
import style0 from "./ClassificationTile.vue?vue&type=style&index=0&id=730651dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730651dc",
  null
  
)

export default component.exports